<template>

    <div class="d-flex  align-items-center">
        <input :type="type" class="form-check-input" :name="name" :value="valueX" :id="id"
            @change="$emit('update:modelValue', valueX)" :checked="modelValue == valueX" />
        <label class=" col-form-label" :for="id" style="margin-inline-start: 10px;">{{ label }}</label>
    </div>
</template>

<script setup lang="ts">
import { computed, defineProps } from "vue";

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: "",
    },
    label: { type: String },
    name: { type: String },
    id: { type: String }, 
    valueAttr: { type: [String, Number], },
    type: { type: String, default: 'radio' },
     disabled: { type: Boolean, default: false },
     v: {
        type: Object,
    },
});

const valueX = computed(() => {
    if (props.valueAttr === 1 || props.valueAttr === 0) {

        return props.valueAttr === 1 ? 1 : 0;
    }
    else {
        return props.valueAttr
    }

}) 
</script>

<style scoped>

.col-form-label {
    font-weight: bold;
}

</style>
